import BookImage from '../../../../components/BookImage/BookImage';
import { Book as BookModel } from '../../../../models/books'
import styles from './Book.module.scss';

type BookProps = {
  book: BookModel
}

export const Book = ({ book }: BookProps) => {
  return(
    <div className={styles.container}>
      <div className={styles.containerImage}>
      <BookImage 
        className={styles.image} 
        path={book?.imageLink} 
        author={String(book?.author)}
        name={book?.name}
        />
      </div>
    </div>
  )
}